import React from 'react'
import { Text, TouchableOpacity, View } from 'react-native'
import styles from '../../styles'

const linkText = (props) => {
  const {
    accessibilityLabel, testID, onPress, children, last,
  } = props
  return (
    <TouchableOpacity
      style={[styles.moreInformationCell, !last && styles.bottomBorder]}
      accessible
      accessibilityLabel={accessibilityLabel}
      testID={testID}
      onPress={onPress}
    >
      <View style={styles.learnMoreView}>
        <Text style={styles.actionBlueLink}>
          {children}
        </Text>
      </View>
    </TouchableOpacity>
  )
}

export default linkText
